import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';
import { defaultPadding } from 'js/components/core/Backdrop';

export default styled.div`
  margin-top: ${defaultPadding};
  border: 1px solid ${lightGrey2Color};
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom-width: 0;
  padding: 1rem;
  font-size: 0.9rem;
`;
